import React from 'react';
import { Tabs } from 'antd';
import UpcomingEventsTable from './UpcomingEventsTable';
import DashboardCalendar from './DashboardCalendar';

const { TabPane } = Tabs;

const EventsSwitcher: React.FC = () => {
  return (
    <div style={{ background: 'transparent', borderRadius: 8 }}>
      <Tabs defaultActiveKey="calendar" tabBarStyle={{ marginBottom: 0 }}>
        <TabPane tab="Kalendar" key="calendar">
          <DashboardCalendar />
        </TabPane>
        <TabPane tab="Tabela" key="table">
          <UpcomingEventsTable />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default EventsSwitcher; 